import { giphyRed } from '@giphy/js-brand'
import { uniqueId } from 'lodash'
import { useContext } from 'react'
import { IconButton, TextInput } from 'ui'
import { TextInputProps } from 'ui/src/components/controls/text-input'
import { UgeLayersContext } from '../../../contexts/layers'
import { CaptionLayer } from '../../../types'

type Props = {
    caption: CaptionLayer
    className?: string
    textInputOptions?: Partial<TextInputProps>
    showAdd?: boolean
    onAdd?: (captionId: string) => void
}

const CaptionsEditorCaptionInput = ({
    caption: { id, props },
    className,
    textInputOptions = {},
    onAdd: onAddCallback,
}: Props) => {
    const { addLayer, updateLayer, removeLayer } = useContext(UgeLayersContext)

    const onAdd = () => {
        const id = uniqueId('uge-caption-')

        addLayer({
            id,
            type: 'caption',
            props: {
                text: '',
                textStyle: props.textStyle,
            },
        })

        onAddCallback?.(id)
    }

    const onRemove = () => {
        removeLayer(id)
    }

    const onTextChange = (value: string) => {
        if (value !== props.text) {
            updateLayer(id, {
                text: value,
            })
        }
    }

    return (
        <TextInput
            {...textInputOptions}
            className={className}
            defaultValue={props.text}
            multiline
            placeholder="Enter a caption"
            size="medium"
            style={{ maxHeight: 100 }}
            onChange={onTextChange}
        >
            {!!onAddCallback ? (
                <IconButton gradient="indigo-purple" icon="add" iconScale={0.9} size="medium" onClick={onAdd} />
            ) : (
                <IconButton
                    color="#fff"
                    icon="trash"
                    iconColor={giphyRed}
                    iconScale={0.8}
                    size="medium"
                    onClick={onRemove}
                />
            )}
        </TextInput>
    )
}

export default CaptionsEditorCaptionInput
